import dynamic from 'next/dynamic';

const TrustpilotWidgetClient = dynamic(
  () => import('./TrustpilotWidget').then((comp) => comp.TrustpilotWidget),
  {
    ssr: false
  }
);

export default TrustpilotWidgetClient;
